const GenerateChartData = (list, label, totalTime, countOfParts = 5) => {
    const dataList = [];
    list.forEach((data, index) => {
      if (index < countOfParts) {
        const percentage = Math.round((parseInt(data.total_time, 10) / parseInt(totalTime, 10)) * 100);
        const newLable = data?.[label]?.toString().trim();
        dataList.push({
          id: data?.[label],
          label: data?.[label],
          value: percentage,
          newValue: newLable.length >= 15 ? newLable.substring(0, 15).concat('...') : newLable, // figure it out
        });
      }
    });
    const sum = dataList.reduce((partialSum, a) => partialSum + a.value, 0);
    if (list?.length && Math.round(100 - sum) !== 0) {
      dataList.push({
        id: 'Others',
        label: 'Others',
        value: 100 - sum,
        newValue: 'Others',
      });
    }
    return dataList;
  };

export default GenerateChartData;